module.exports = __webpack_public_path__ + "static/media/caution1.345c21b9.png";